var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9181 27.8602C6.37457 27.8602 0.257141 21.6578 0.257141 13.9951C0.257141 6.33889 6.37457 0.133301 13.9181 0.133301H29.7993C37.3429 0.133301 43.4571 6.33889 43.4571 13.9951C43.4571 21.661 37.3429 27.8666 29.7993 27.8666L13.9181 27.8602ZM29.4404 22.9761C34.3255 22.9761 38.2894 18.9562 38.2894 13.9949C38.2894 9.04014 34.3255 5.02344 29.4404 5.02344H14.2739C9.38883 5.02344 5.42806 9.04014 5.42806 13.9949C5.42806 18.9562 9.38883 22.9761 14.2739 22.9761H29.4404Z",
    fill: "#C74634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlogo);
export default __webpack_public_path__ + "static/media/ologo.375b8ded5b582a23bb85954dbd69fbbf.svg";
export { ForwardRef as ReactComponent };